import React from 'react';
import styled from 'styled-components';
import { GridWrapper } from './GridWrapper';

const RowsWrapperDiv = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow: hidden;
`

export const RowsWrapper = (props) => {
    return <RowsWrapperDiv>
        {GridWrapper({
            ...props,
            direction: 'vertical'
        })}
    </RowsWrapperDiv>
}